<template>
  <ThemeDefaultLayoutPage
    v-if="body"
    :title="body.title || section.title"
    :description="section.description"
    :breadcrumbs="breadcrumbItem"
    :show-category="false"
    custom-padding="lg:!tw-py-11 !tw-py-6"
  >
    <DisplayHTMLContent
      class="about-us-content lg:tw-max-w-[900px] md:tw-max-w-[720px] tw-mx-auto"
      :model-value="body.content"
    />
  </ThemeDefaultLayoutPage>
</template>

<script lang="ts" setup>
import { buildFaqPageSchema, dedupeFaqItems, extractFaqsFromHtml } from '~/composables/utils/faq'

const { body, section, breadcrumbItem } = await useAboutUsPage();
const faqItems = computed(() => dedupeFaqItems(extractFaqsFromHtml(body.value?.content || '')))
useHead(() => faqItems.value.length ? {
  script: [{ type: 'application/ld+json', children: JSON.stringify(buildFaqPageSchema(faqItems.value)) }],
} : {})
</script>
